import { getNestedProperty } from '@opallabs/lambda'
import {
  Response,
  ResponseCollection,
  State,
  StateKeys,
} from '../../../../types'

export const getResponse =
  (id: string) =>
  (state: State): Response | undefined =>
    state.jsonApiEntities &&
    state.jsonApiEntities.response &&
    state.jsonApiEntities.response[id]

export const getResponses = (state: State): ResponseCollection | undefined =>
  getNestedProperty<ResponseCollection>(
    state,
    StateKeys.jsonApiEntities,
    StateKeys.response
  )

export const getResponsesByAssignment = (
  state: State,
  assignmentId: string
): Response[] => {
  const responses = getResponses(state)
  if (!responses) return []

  return Object.values(responses).filter(
    (response) =>
      getNestedProperty<string>(
        response,
        'relationships',
        'assignment',
        'id'
      ) === assignmentId
  )
}
